import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getService = createAsyncThunk('getService/getService', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getService(payload.slug, payload.lang);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
